import { InputText } from "primereact/inputtext";
import * as React from "react";
import { useTranslation } from "react-i18next";

const PrwcSearch = (props: any) => {
  const { t } = useTranslation();

  return (
    <span className="p-input-icon-left">
      <i className="pi pi-search" />
      <InputText
        className={props.className}
        value={props.value || ""}
        onChange={(e: any) => props.onChange(e.target.value)}
        placeholder={props.placeholder || t("generic.label.search")}
      />
    </span>
  );
};

export default PrwcSearch;
